import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Ar } from "@/deck/typography/Ar";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { user, signIn } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={from} replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
      nav(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "تعذّر تسجيل الدخول.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div dir="rtl" className="grid min-h-screen place-items-center bg-bg px-6 font-deck text-text">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold">Hayya Stage</h1>
          <p className="mt-1 text-sm text-text-muted">سجّل الدخول للمتابعة</p>
        </div>

        <label className="block">
          <span className="mb-1 block text-sm text-text-muted">البريد الإلكتروني</span>
          <input
            type="email" required autoComplete="username" dir="ltr"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-border bg-surface-raised px-4 py-2.5 outline-none focus:border-accent"
          />
        </label>

        <label className="block">
          <span className="mb-1 block text-sm text-text-muted">كلمة المرور</span>
          <input
            type="password" required autoComplete="current-password" dir="ltr"
            value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-border bg-surface-raised px-4 py-2.5 outline-none focus:border-accent"
          />
        </label>

        {error && (
          <p role="alert" className="rounded-lg bg-danger/10 px-4 py-2 text-sm text-danger-ink">
            <Ar t={error} />
          </p>
        )}

        <button
          type="submit" disabled={busy}
          className="w-full rounded-lg bg-accent px-4 py-2.5 font-semibold text-accent-contrast disabled:opacity-60"
        >
          {busy ? "…" : "دخول"}
        </button>
      </form>
    </div>
  );
}
